import React, {useEffect, useRef, useState} from 'react';
import {useLocaleKeys} from '../../../../../../locale-keys/LocaleKeys';
import {NextStepButton} from '../../../StepsManager/Components/NextStepButton/NextStepButton';
import {useControllerProps} from '../../../../Widget/ControllerContext';
import {classes} from './DeliveryMethodOpen.st.css';
import {DeliveryMethodStepDataHook} from '../DeliveryMethodStep';
import {StatesButtonStates} from 'wix-ui-tpa/cssVars';
import {DeliveryMethodSection} from '../../../../DeliveryMethodSection/DeliveryMethodSection';
import {AddShippingAddressSection} from './AddShippingAddressSection/AddShippingAddressSection';

export const DeliveryMethodOpen = () => {
  const localeKeys = useLocaleKeys();
  const {
    deliveryMethodStore,
    checkoutStore: {onDeliveryMethodContinue},
  } = useControllerProps();
  const {isUpdatingShippingOption, canShipToDestination} = deliveryMethodStore;
  const [buttonState, setButtonState] = useState(StatesButtonStates.IDLE);
  const [buttonDisabledState, setButtonDisabledState] = useState(!canShipToDestination);
  const sectionRootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setButtonDisabledState(isUpdatingShippingOption || !canShipToDestination);
  }, [isUpdatingShippingOption, canShipToDestination]);

  const submit = () => {
    setButtonDisabledState(true);
    setButtonState(StatesButtonStates.IN_PROGRESS);
    onDeliveryMethodContinue();
  };

  return (
    <div data-hook={DeliveryMethodStepDataHook.open} className={classes.root} ref={sectionRootRef}>
      <AddShippingAddressSection />
      <DeliveryMethodSection />
      <div className={classes.nextStepButton}>
        <NextStepButton
          onClick={() => void submit()}
          text={localeKeys.checkout.continue_button_label()}
          dataHook={DeliveryMethodStepDataHook.continueButton}
          disabled={buttonDisabledState}
          buttonState={buttonState}
        />
      </div>
    </div>
  );
};
